import { signOut } from 'aws-amplify/auth'
import { Modal, sendToSentry, tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'
import { CaretRightIcon } from '@phosphor-icons/react'
import { ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { redirectToAppraiserUIHome } from 'ClientPortal/src/common/navigation'
import { useFlags } from 'ClientPortal/src/context/FeatureFlagContext'
import type { RootUser as User } from '@einwert/valuation-api-client'

export function isRestrictedAppraiser(user: User | undefined, isFullAppraiserUIViewMode: boolean) {
    return user?.role === 'appraiser' && !isFullAppraiserUIViewMode
}

export function RestrictedAppraiserGate({ children, user }: { children: ReactNode; user?: User }) {
    const { isFullAppraiserUIViewMode } = useFlags()

    return isRestrictedAppraiser(user, isFullAppraiserUIViewMode) ? <RestrictedAppraiserModal /> : children
}

export function RestrictedAppraiserModal() {
    const { t } = useTranslation('pages', { keyPrefix: 'authenticatedApp.restrictedAppraiser' })
    const [isRedirecting, setIsRedirecting] = useState(false)

    const handleRedirect = async () => {
        setIsRedirecting(true)
        try {
            await signOut()
            redirectToAppraiserUIHome()
        } catch (error) {
            sendToSentry(error)
            setIsRedirecting(false)
        }
    }

    return (
        <Modal
            isOpen
            onClose={() => undefined}
            disableBackdropClose
            showLoading={isRedirecting}
            title={t('title')}
            footerProps={{
                primaryButton: {
                    text: t('action'),
                    disabled: isRedirecting,
                    onClick: () => void handleRedirect(),
                    rightIcon: <CaretRightIcon />,
                },
            }}
        >
            <Typography variant="textS" color={tokens.ColorTextDefault}>
                {t('description')}
            </Typography>
        </Modal>
    )
}
